import { CalculatorBase, SphericalCalculator } from "../../geodesy";
import { Geo2 } from "../geography.position";
import { GeoPolyline } from "./geography.polyline";
import { GeoShapeType } from "./geography.shapes.interfaces";
export class GeoPolygon extends GeoPolyline {
    static FromCircle(center, radius, step, p) {
        const processor = p ?? CalculatorBase.Shared ?? SphericalCalculator.Shared;
        const points = [];
        const angle = 360 / step;
        const r = radius;
        const lat = center.lat;
        const lon = center.lon;
        for (let i = 0; i < 360; i += angle) {
            points.push(processor.getLocationAtDistanceAzimuth(lat, lon, r, i));
        }
        return new GeoPolygon(points);
    }
    static FromRectangle(center, width, height, p) {
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        p = p ?? CalculatorBase.Shared ?? SphericalCalculator.Shared;
        const lat = center.lat;
        const lon = center.lon;
        const N = p.getLocationAtDistanceAzimuth(lat, lon, halfHeight, 0);
        const E = p.getLocationAtDistanceAzimuth(lat, lon, halfWidth, 90);
        const S = p.getLocationAtDistanceAzimuth(lat, lon, halfHeight, 180);
        const W = p.getLocationAtDistanceAzimuth(lat, lon, halfWidth, 270);
        return new GeoPolygon([new Geo2(N.lat, W.lon), new Geo2(N.lat, E.lon), new Geo2(S.lat, E.lon), new Geo2(S.lat, W.lon)]);
    }
    constructor(p) {
        super(p, GeoShapeType.Polygon);
    }
}
//# sourceMappingURL=geography.polygon.js.map